jQuery(($) => {
  class Slider {
    constructor(element, args = {}) {
      this._ = element;
      this._element = $(element);
      this._list         = this._element.find('.o-slider-carousel__list');
      this._prev         = this._element.find('.o-slider-carousel__arrow.o-slider-carousel__arrow--prev');
      this._next         = this._element.find('.o-slider-carousel__arrow.o-slider-carousel__arrow--next');
      this._currentIndex = this._element.find('.o-slider-carousel__pagination__current');
      this._progressBar  = this._element.find('.o-slider-carousel__progress__fill');
      this._swiper       = this._element.find('swiper-container');

      this._shouldLoop    = this._element.hasClass('o-slider-carousel--loop');
      this._showOverflow  = this._element.hasClass('o-slider-carousel--show-overflow');

      this._args = {
        freeMode: false,
        keyboard: {
          enabled: true,
          onlyInViewport: false,
          pageUpDown: false,
        },
        loop: this._shouldLoop,
        slidesPerView: 'auto',
        spaceBetween: 12,
        preventClicks: false,
        preventClicksPropagation: false,
        mousewheel: {
          forceToAxis: true
        },
        simulateTouch: false,
        speed: 250,
        injectStyles: this._showOverflow ? [
          `
            .swiper {
              overflow: visible;
            }
          `
        ] : null
      }

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.initSwiper();
      this.setupHandlers();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Init SwiperJS
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    initSwiper() {
      const swiperEl = document.querySelector('swiper-container');
      Object.assign(swiperEl, this._args);
      swiperEl.initialize();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._prev.on('click', () => {
        this._swiper[0].swiper?.slidePrev();
      });

      this._next.on('click', () => {
        this._swiper[0].swiper?.slideNext();
      });

      const eventName = this._shouldLoop ? 'swiperrealindexchange' : 'swipersnapindexchange';

      this._swiper.on(eventName, (event) => {
        const swiperData = event.originalEvent.detail[0];
        const currentSlide = swiperData.previousIndex;
        const slideCount = swiperData.slides.length;
        let nextSlide = this._shouldLoop ? swiperData.realIndex : swiperData.snapIndex;
        if (swiperData.isEnd) {
          nextSlide = slideCount - 1;
        }

        const progress = this._shouldLoop ? swiperData.progressLoop : swiperData.progress;

        this._currentIndex.text(nextSlide + 1);
        this._progressBar.css('width', (progress > 0 ? progress : 0.001) * 100 + '%');
        if (nextSlide === 0 && currentSlide === slideCount - 1) {
          this._element.addClass('o-slider-carousel--resetting');

          setTimeout(() => {
            this._element.removeClass('o-slider-carousel--resetting');
          }, 500);
        }

        if (swiperData.isBeginning && !this._shouldLoop) {
          this._prev.addClass('disabled');
        } else {
          this._prev.removeClass('disabled');
        }

        if (swiperData.isEnd && !this._shouldLoop) {
          this._next.addClass('disabled');
        } else {
          this._next.removeClass('disabled');
        }

        // If slide has a video, stop it before sliding
        // const currentSlideElement = slick.$slides.eq(currentSlide);
        // if (currentSlideElement && currentSlideElement.find('.m-video').length) {
        //   const videoEl = currentSlideElement.find('.m-video')[0];
        //   videoEl?.video?.handleStop();
        // }
      });
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.slider = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined') _[i].slider = new Slider(_[i], opt);
      else ret = _[i].slider[opt].apply(_[i].slider, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.o-slider-carousel').slider();
});
